<template>
  <div class="bawLoginPage">
    
    <template v-if="!loaded">
      <div class="loginErrorMsg">
        <img src="/static/refresh/bawrefresh.png" />
        <div class="errorText">{{errorText}}</div>
        <mu-flat-button label="退出登录" primary fullWidth class="refreshButton" @click="refreshLogin()"></mu-flat-button>
      </div>
    </template>    
    

    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import md5 from 'js-md5'
import UserCache from '../util/cache'
export default {
  data () {
    return {
      loaded:true,
      token:'',
      errorText:'',
      appClient:this.$route.query.client
    }
  },
  methods: {
    
  },
  mounted(){
    //this.$refs.XRtoast.load('加载中')
    //alert(window.location.href)

    if(this.appClient){
      window.localStorage.appClient= this.appClient
    }

    this.token = this.$route.query.token
    if(!this.token){
      this.loaded = false
      this.errorText ='非法的请求'
      return;
    }    

    var autoredirect= this.$route.query.autoredirect
    if(autoredirect){
      var sessionId = this.$store.state.user.SessionId
      if(sessionId){
        this.$router.goBack()
      }

      this.bawLogin()
    }else{    
      this.$store.dispatch('DelUser')
      //this.UserCache.delUser() 
 
      this.$store.dispatch('SETBawToken', this.token)

      var auth = this.$route.query.api
      if(auth){
        this.$store.dispatch('SETBawAuth', auth)
      }
      this.redirect()
    }
    //console.log(this.token)
  },
  methods: {
    refreshLogin(){
      if(this.appClient == 'ios'){
        window.webkit.messageHandlers.ajax.postMessage({fun:'exit'})
      }else{
        ajax.exit();
      }
    },
    redirect(){      
      var redirect = this.$route.query.backurl              
      if(!redirect){
        redirect = this.$route.query.redirect
        if(!redirect){
          redirect = '/'
        }
      }else{
        redirect = redirect.replace('http://m.xurigo.com/#','')
        redirect = redirect.replace('https://m.xurigo.com/#','')
        redirect = redirect.replace('http://192.168.0.151:8080/#','')
		redirect = redirect.replace('http://shangquan.xurigo.com/#','')
      }
      this.$router.push(redirect)
    },
    bawLogin(){
      const ths = this;
      this.$post('/Shop/UserServer/BawLogin', {token: encodeURIComponent(this.token)})
        .then(function (res) {
          ths.loaded = false
          if(res.IsSuccess){
              //ths.$refs.XRtoast.success(res.Msg)   
              
              if(ths.isRemember){
                window.localStorage['XRLoginRememberUserName'] = json.username
              }else{
                window.localStorage.removeItem('XRLoginRememberUserName')
              }

              if(!res.Data.HeadPic){
                res.Data.HeadPic = 'http://frontend.xurigo.com/icon/person.jpg'
              }
              
              ths.$store.dispatch('SetUser', res.Data.SessionId)
              
              ths.$refs.XRtoast.hide()  
                            
              if(!res.Data.isTestEmail && !res.Data.isTestPhone){
                redirect = "/usercenter/mobileBind"
              }

              ths.redirect()
            }
            else{              
              ths.$refs.XRtoast.hide()
              //ths.$refs.XRtoast.failed(res.Msg,true) 
              ths.errorText = res.Msg
            }  
        })
        .catch(function (err) {
          ths.loaded = false
          console.log(err)
          ths.errorText = err
        })
    }
  }
}
</script>
<style>
body .bawLoginPage{
    background: #eee;
}

.bawLoginPage .loginErrorMsg{
  overflow: hidden;
  text-align: center;
  padding: 80px 0 0;
}
.bawLoginPage .loginErrorMsg img{
  width: 50%;  
}
.bawLoginPage .loginErrorMsg .errorText{
  font-size: 18px;
  color:#333;
  padding: 20px 0 40px;
}
.bawLoginPage .loginErrorMsg .refreshButton{
  width:60%;
  color:#E7C583;
  border: 1px solid #E7C583;
}
</style>




// WEBPACK FOOTER //
// src/pages/bawLogin.vue